/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IEspecialty } from 'app/shared/model/especialty.model';
import { IHospital } from 'app/shared/model/hospital.model';
import { IClinicalDictionaryType } from 'app/shared/model/clinical-dictionary-type.model';

export interface IPatientAttributeType {
  id?: string;
  active?: boolean;
  lastUpdated?: number;
  timestampEntry?: number;
  microSec?: number;
  cursor?: number;
  title?: string | null;
  unitsOfMeasure?: string | null;
  valueType?: string | null;
  valueRange?: string | null;
  group?: string | null;
  isReqForRegistration?: boolean | null;
  specialty?: IEspecialty | null;
  hospital?: IHospital | null;
  parent?: IPatientAttributeType | null;
  clinicalDictionaryType?: IClinicalDictionaryType | null;
}

export const defaultValue: Readonly<IPatientAttributeType> = {
  active: false,
  isReqForRegistration: false,
};
